import { OktaAuth } from "@okta/okta-auth-js";

const BASE_PATH = import.meta.env.VITE_BASE_PATH ?? "";

export const OktaAuthClient = new OktaAuth({
  issuer: `${import.meta.env.VITE_OKTA_ISSUER_URL}`,
  clientId: `${import.meta.env.VITE_OKTA_CLIENT_ID}`,
  redirectUri: `${window.location.origin}${BASE_PATH}/authorization-code/callback`,
  postLogoutRedirectUri: window.location.origin + BASE_PATH,
  restoreOriginalUri: (_oktaAuth, originalUri) => {
    window.location.replace(originalUri || window.location.origin + BASE_PATH + "/home");
    return Promise.resolve();
  }
});

// Simple in-memory cache for user email to prevent duplicate calls
let userEmailPromise: Promise<string> | null = null;

// Simple utility function to get user email with request deduplication
export const getUserEmail = async (): Promise<string> => {
  // If there's already a pending request, return the same promise
  if (userEmailPromise) {
    return userEmailPromise;
  }

  // Create a new promise and cache it
  userEmailPromise = (async () => {
    try {
      const user = await OktaAuthClient.getUser();
      if (!user?.email) {
        throw new Error("User email not available");
      }
      return user.email;
    } finally {
      userEmailPromise = null;
    }
  })();

  return userEmailPromise;
};
